import colors from '@lmc/common/constants'
import { AvatarsList, SeenBy } from '@lmc/ui-kit'
import useFeatureFlags from 'hooks/useFeatureFlags'

const SeenBySection = ({
  filteredAvatars,
}: {
  filteredAvatars: AvatarsList
}) => {
  const flags = useFeatureFlags({
    flagNames: ['risk_assessments_mark_as_read'],
  })?.data

  const flagMarkAsRead2Enabled = flags?.risk_assessments_mark_as_read?.enabled

  if (!flagMarkAsRead2Enabled) return

  return (
    <div
      className="lmc-card"
      style={{
        ...styles.cardContainer,
      }}
    >
      <SeenBy
        title="Which team members have seen this"
        avatars={filteredAvatars}
        seenByText={`Seen by ${filteredAvatars.length} team member${filteredAvatars.length !== 1 ? 's' : ''}`}
      />
    </div>
  )
}

const styles = {
	cardContainer: {
	  background: colors.white,
	  padding: '18px 24px',
	  whiteSpace: 'pre-wrap',
	  width: '100%',
	  fontWeight: 500,
	  color: colors.black,
	  fontSize: 16,
	},
  }

export default SeenBySection
